"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var theme_1 = require("../../utils/theme");
var context_1 = require("./context");
var Item_1 = tslib_1.__importDefault(require("./Item"));
var helper_1 = require("../../utils/helper");
var Group = (function (_super) {
    tslib_1.__extends(Group, _super);
    function Group() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, selectedColors = _a.selectedColors, label = _a.label, colors = _a.colors, labelClassName = _a.labelClassName, labelStyle = _a.labelStyle, hoverEffect = _a.hoverEffect, onHoverColor = _a.onHoverColor, onChange = _a.onChange, onClickColor = _a.onClickColor, rest = tslib_1.__rest(_a, ["prefixCls", "className", "style", "children", "selectedColors", "label", "colors", "labelClassName", "labelStyle", "hoverEffect", "onHoverColor", "onChange", "onClickColor"]);
            var classes = classNames(prefixCls, className);
            var containerClasses = classNames(prefixCls + "-container");
            var labelClasses = classNames(prefixCls + "-label", labelClassName);
            return (h("div", tslib_1.__assign({ className: classes, style: style }, rest),
                label && h("div", { className: labelClasses, style: labelStyle }, label),
                h("div", { className: containerClasses },
                    h(context_1.GroupContext.Provider, { value: selectedColors }, colors === null || colors === void 0 ? void 0 :
                        colors.map(function (color) {
                            return h(Item_1.default, { key: color, color: color, hoverEffect: hoverEffect, onClick: function () { return _this.handleClick(color); }, onMouseEnter: function () { return onHoverColor(color); } });
                        }),
                        children))));
        };
        return _this;
    }
    Group.prototype.handleClick = function (clickColor) {
        var _a = this.props, selectedColors = _a.selectedColors, onChange = _a.onChange, onClickColor = _a.onClickColor;
        onClickColor(clickColor);
        if (selectedColors.indexOf(clickColor) !== -1) {
            onChange(selectedColors.filter(function (selectedColor) { return selectedColor !== clickColor; }));
        }
        else {
            onChange(selectedColors.concat(clickColor));
        }
    };
    Group.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Group;
}(React.Component));
exports.default = Group;
Group.defaultProps = {
    prefixCls: 'dui-colorpicker-group',
    selectedColors: [],
    onChange: helper_1.emptyFn,
    onClickColor: helper_1.emptyFn,
    onHoverColor: helper_1.emptyFn,
};
